export default __webpack_public_path__ + "static/media/WM0440.34I-43832_-26157_0.afcae79c.jpg";